import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderBy',
  standalone: true,
})
export class SortByPipe implements PipeTransform {
  /**
   * @description Sorts the input array in descending order by the fieldToOrderBy passed in.
   **/
  public transform<T>(value: T[], fieldToOrderBy: keyof T): T[] {
    const sortedCopy = [...value];
    return this.sortByParameter(sortedCopy, fieldToOrderBy);
  }

  private sortByParameter<T>(list: T[], fieldToOrderBy: keyof T): T[] {
    list.sort((eleA, eleB) => {
      const valA = eleA[fieldToOrderBy];
      const valB = eleB[fieldToOrderBy];

      // 1. Handle null or undefined values safely
      const isNullishA = valA === null || valA === undefined;
      const isNullishB = valB === null || valB === undefined;
      if (isNullishA && isNullishB) return 0;
      if (isNullishA) return 1;
      if (isNullishB) return -1;

      // 2. If they are numbers, subtraction is safe after narrowing the type
      if (typeof valA === 'number' && typeof valB === 'number') {
        return valB - valA; // Descending order
      }

      // 3. If they are strings, use localeCompare for proper alphabetical sorting
      if (typeof valA === 'string' && typeof valB === 'string') {
        return valB.localeCompare(valA); // Descending order
      }

      // 4. Fallback for mixed or other types (like Dates or Booleans)
      if (valA < valB) return 1;
      if (valA > valB) return -1;
      return 0;
    });

    return list;
  }
}
